// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonEnums = {
  examStatus: {
    draft: "下書き",
    published: "公開済み",
    running: "実施中",
    ended: "終了",
    archived: "アーカイブ済み",
  },
  environmentInstanceStatus: {
    provisioning: "作成中",
    ready: "準備完了",
    running: "稼働中",
    evaluated: "評価済み",
    destroyed: "破棄済み",
    failed: "失敗",
    expired: "期限切れ",
  },
  questionStatus: {
    draft: "下書き",
    published: "公開済み",
    archived: "アーカイブ済み",
  },
  paperStatus: {
    draft: "下書き",
    published: "公開済み",
    archived: "アーカイブ済み",
  },
  difficulty: {
    easy: "易しい",
    medium: "普通",
    hard: "難しい",
  },
  paperType: {
    fixed_manual: "固定試験用紙 - 手動",
    fixed_rule: "固定試験用紙 - ルール",
    differentiated: "差分試験用紙",
    variant: "バリアント試験用紙",
    adaptive: "適応型試験用紙",
  },
  judgeVerdict: {
    accepted: "正解",
    wrong_answer: "不正解",
    compile_error: "コンパイルエラー",
    pending: "待機中",
    runtime_error: "実行時エラー",
    time_limit_exceeded: "時間制限超過",
  },
  resultVisibility: {
    hidden: "非表示",
    after_submit: "提出後に表示",
    after_publish: "公開後に表示",
  },
  answerVisibility: {
    hidden: "非表示",
    analysis_only: "解説のみ表示",
    full: "解答と解説を表示",
  },
  publishScoreMode: {
    immediate: "即時公開",
    manual: "手動公開",
  },
  scoreRecordSource: {
    auto: "自動採点",
    environment: "環境採点",
    judge: "ジャッジ採点",
    ai: "AI 採点",
    manual: "手動採点",
    review: "レビュー採点",
  },
  scoreRecordStatus: {
    valid: "有効",
    invalid: "無効",
    pending: "保留",
  },
  scoreRecordComments: {
    autoObjectiveScoring: "自動客観式採点",
    manualReview: "手動レビュー",
    flagValidationPassed: "Flag 検証成功",
    flagValidationFailed: "Flag 検証失敗",
    flagValidatedDeferred: "提出時 Flag 遅延検証成功",
    flagValidationFailedDeferred: "提出時 Flag 遅延検証失敗",
    noFlagSubmitted: "Flag 未提出",
    attackDefenseFlagSnapshotMissing: "攻防 Flag スナップショット欠落",
    judgeResult: "ジャッジ結果",
  },
  questionType: {
    single_choice: "単一選択",
    multiple_choice: "複数選択",
    judgment: "正誤判定",
    short_answer: "記述式",
    code: "コード問題",
    practical: "実技問題",
    attack_defense: "攻防問題",
  },
  questionTypeShort: {
    single_choice: "単一",
    multiple_choice: "複数",
    judgment: "正誤",
    short_answer: "記述",
    code: "コード",
    practical: "実技",
    attack_defense: "攻防",
    mixed: "総合",
  },
  attemptStatus: {
    assigned: "未着手",
    contract_missing: "状態欠落",
    not_started: "未開始",
    started: "受験中",
    submitted: "提出済み",
    graded: "採点済み",
    expired: "期限切れ",
    absent: "欠席",
    cancelled: "取消済み",
    in_progress: "受験中",
    abandoned: "放棄",
  },
  reviewStatus: {
    pending: "採点待ち",
    completed: "完了",
  },
  userStatus: {
    active: "有効",
    inactive: "無効",
    locked: "ロック済み",
    disabled: "停止",
  },
} as const;
